/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import * as React from 'react';
import * as MsDyn365 from '@msdyn365-commerce/core';
import classnames from 'classnames';

import { IExtHtmlBlockProps } from './ext-html-block.props.autogenerated';

export interface IExtHtmlBlockViewProps extends IExtHtmlBlockProps<{}> {
    content?: React.ReactNode;
    className?: string;
}

/**
 *
 * HtmlBlock component
 * @extends {React.PureComponent<IExtHtmlBlockProps<{}>>}
 */
class ExtHtmlBlock extends React.PureComponent<IExtHtmlBlockProps<{}>> {
    private script: React.RefObject<HTMLDivElement>;

    constructor(props: IExtHtmlBlockProps<{}>) {
        super(props);
        this.script = React.createRef<HTMLDivElement>();
    }

    public componentDidMount(): void {
        useScript(this.props);
        if (window.Script) {
            window.Script.loadFromElement(this.script.current, true);
        }
    }
    public render(): JSX.Element | null {
        const { content, className } = this.props.config;
        const text = content && (
            <MsDyn365.RichTextComponent
                text={content}
                editProps={{ onEdit: this.handleTextChange, requestContext: this.props.context.request }}
            />
        );
        const htmlBlockViewProps = {
            ...this.props,
            content: text,
            className: classnames('ms-html-block', className)
        };
        return this.props.renderView(htmlBlockViewProps) as React.ReactElement;
    }

    public handleTextChange = (event: MsDyn365.ContentEditableEvent) => (this.props.config.content = event.target.value);
}

function useScript(props: IExtHtmlBlockProps<{}>): void {
    const existing = document.querySelector(`script[data-name*="${props.config.widgetName}"]`);
    if (!existing) {
        const script = document.createElement('script');
        script.src = props.config.scriptLink || '';
        script.async = true;
        script.type = 'text/javascript';
        script.dataset.name = props.config.widgetName;
        document.head.appendChild(script);
    }
}

export default ExtHtmlBlock;
